// extracted by mini-css-extract-plugin
module.exports = {"Asset":"Asset_Asset__1dBcX","spinner":"Asset_spinner__3mHLk"};